module.exports = "/_next/static/images/big-cluster-28bc43fb006c4cb758519309526e6df8.png";